import APIClient from '@app/services/APIClient';
import { transformData } from '@app/services/loan/dataTransformer';
import ui from '@app/services/loan/ui';
import Loan from '@engine/engine/loan/Loan';

// https://webpack.js.org/guides/public-path/
__webpack_public_path__ = window.resourceBaseUrl || '';

const dataset = document.querySelector('#app').dataset;
const loanRatesHandler = (rates) => {
    // for testing purposes may be used instead of rates form api call:
    // const rawData = require('../../../dummy-data/loan/different-category.js').default;
    // const SPPIRate = require('../../../dummy-data/loan/SPPIRate.js').default;

    const SPPIRate = rates[0].data.data[0];
    const rawData = rates[1].data.data[0];

    const rawDefaultValues = JSON.parse(dataset.default);
    const transformedData = transformData({ rawData, rawDefaultValues });
    const externalHandler = (userInput) => {
        if (!loan) {
            loan = new Loan(SPPIRate, rawData, userInput);
        } else {
            loan.setInput(userInput);
        }

        return loan.calculate();
    };
    let loan;

    // TODO: refactor this
    transformedData.ctaLink = dataset.ctaLink?.trim();
    transformedData.ctaText = dataset.ctaText?.trim();
    transformedData.detailsLink = dataset.detailsLink?.trim();
    transformedData.detailsText = dataset.detailsText?.trim();
    transformedData.insuranceToggle = 'true' === dataset.insuranceToggle;
    transformedData.hidden = dataset.hidden ? JSON.parse(dataset.hidden) : [];

    ui.init({ data: transformedData, externalHandler });
};

const geoHandler = () => {
    const COOKIE_REG = /^APPLICATION_CONTEXT_CITY$/;
    const MOSCOW_CITY_ID = 21;
    let cityId = document.cookie
        .split(';')
        .filter((cookie) => COOKIE_REG.test(cookie.trim().split('=')[0]))
        .reduce((val, cookie) => cookie.split('=')[1], '');

    cityId = parseInt(cityId, 10);
    if (isNaN(cityId)) {
        cityId = MOSCOW_CITY_ID;
    }

    APIClient.getLoanRates({ endpoint: dataset.endpoint, cityId: cityId }).then(loanRatesHandler);
};

geoHandler();
